import { render, staticRenderFns } from "./resetPwdSetting.vue?vue&type=template&id=094d2bfb&scoped=true&"
import script from "./resetPwdSetting.vue?vue&type=script&lang=js&"
export * from "./resetPwdSetting.vue?vue&type=script&lang=js&"
import style0 from "./resetPwdSetting.vue?vue&type=style&index=0&id=094d2bfb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094d2bfb",
  null
  
)

export default component.exports